module.exports = __webpack_public_path__ + "static/media/appGuide.399e7e9e.png";